import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { rel as relText } from '../../../utils/rel';
import { classNames } from '../../../utils/classnames';

/**
 * 定义 Footer 组件
 */
const Footer = errorBoundary(
    class extends React.PureComponent {
        static propTypes = { content: PropTypes.array };

        listView(list = []) {
            return list.map((item, index) => (
                <a key={index} className={styles.link} href={item.url} target="_blank" rel={relText}>
                    {item.title}
                </a>
            ));
        }
        /**
         * 渲染组件
         */
        render() {
            const { content } = this.props;
            const copyrightData = content.pop();

            return (
                <div className={styles.footer}>
                    <div className={classNames(styles.foot_link, 'clearfix')}>
                        <div className={styles.list}>{this.listView(content)}</div>
                        <div className={styles.linkr}>
                            <img className={styles.icon} src={require('./icon1.gif')} />
                            <a href="//v.ifeng.com/" target="_blank" rel={relText}>
                                视频
                            </a>
                            ·
                            <a href="//v.ifeng.com/documentary" target="_blank" rel={relText}>
                                纪实
                            </a>
                            ·
                            <a className={styles.mr20} href="//v.ifeng.com/live" target="_blank" rel={relText}>
                                直播
                            </a>
                            <img className={styles.icon} src={require('./icon2.gif')} />
                            <a href="//www.ifeng.com/" target="_blank" rel={relText}>
                                凤凰卫视
                            </a>
                        </div>
                    </div>
                    <div className={styles.copyright}>
                        <span>{copyrightData.text0}</span>
                        <span>{copyrightData.text1}</span>
                        <span>{copyrightData.text2}</span>
                    </div>
                </div>
            );
        }
    },
);

export { Footer };
export default Footer;
